<script>
/**
 * No pinta nada: decide cuándo pedir las filas marcadas como inválidas por la
 * dependencia de fechas de la tabla abierta (utils/filasInvalidas.js), que
 * BotonDeFila pinta en cada fila de la cuadrícula.
 *
 * Va con los componentes de la cabecera de la tabla porque es lo único que el
 * core deja montar una vez por tabla abierta. Se pide la lista:
 *
 *  - al abrir la tabla y cada vez que su regla cambia (se prende, se apaga, se
 *    rompe o se arregla una columna, cambia la holgura...). El backend recalcula
 *    las marcas en ese momento (fechas/receivers.py) y el aviso de la regla
 *    llega en vivo a todos, incluida quien la cambió;
 *  - después de cualquier cambio de filas en la cuadrícula, propio o de otra
 *    persona. Los propios no llegan por el tiempo real (el core no le avisa a
 *    quien editó), y una edición también marca o desmarca filas que nadie tocó
 *    (sus sucesoras): por eso se pide la lista entera y no solo lo que cambió.
 *
 * Con la regla apagada o rota no se pide nada y las marcas se esconden: las que
 * quedaron en la base son de antes y el backend las recalcula al volver.
 */
import {
  olvidar,
  reglaEnUso,
  traer,
} from '@extras_mg/utils/filasInvalidas'

// Las acciones de la cuadrícula que crean, cambian o borran filas: las de quien
// edita (terminan cuando el servidor ya respondió) y las del tiempo real.
const CAMBIAN_FILAS =
  /\/view\/grid\/(createNewRows?|createNewRowInGroup|createNewRowsInGroup|createdNewRow|updateRowValue|updateDataIntoCells|clearValuesFromMultipleCellSelection|updatedExistingRow|deleteExistingRow|deleteSelectedRows|deletedExistingRow|refresh)$/

// Un pegado de 50 filas son 50 avisos del tiempo real: se pide una vez.
const ESPERA_MS = 300

export default {
  name: 'VigiaDeFechas',
  props: {
    database: { type: Object, required: false, default: null },
    table: { type: Object, required: true },
    view: { type: Object, required: false, default: null },
    fields: { type: Array, required: false, default: () => [] },
    isPublicView: { type: Boolean, required: false, default: false },
    storePrefix: { type: String, required: false, default: '' },
  },
  computed: {
    regla() {
      return reglaEnUso(this.$store, this.table.id)
    },
  },
  watch: {
    regla: {
      handler() {
        this.revisar()
      },
      deep: true,
    },
    // La tabla nueva la pide el watcher de arriba (cambia su regla).
    'table.id'(nueva, vieja) {
      olvidar(vieja)
    },
  },
  mounted() {
    this.dejarDeOir = this.$store.subscribeAction({
      after: ({ type }) => {
        if (this.regla && CAMBIAN_FILAS.test(type)) {
          clearTimeout(this.espera)
          this.espera = setTimeout(() => this.revisar(), ESPERA_MS)
        }
      },
    })
    this.revisar()
  },
  beforeUnmount() {
    this.dejarDeOir?.()
    clearTimeout(this.espera)
  },
  methods: {
    async revisar() {
      const tablaId = this.table.id
      if (!this.regla) {
        olvidar(tablaId)
        return
      }
      try {
        await traer(this.$client, tablaId)
      } catch (e) {
        // Sin la lista la cuadrícula sigue funcionando, solo sin marcas.
      }
    },
  },
  render() {
    return null
  },
}
</script>
